import type { Competency } from '../../types/GrowthWheelManagement'
import { isRichTextEmpty } from './RichTextView'

export function trimDesc(value: string | undefined | null): string {
  return (value ?? '').trim()
}

export function getLevelCompletionStatus(competency: Competency) {
  const levels = competency.levelDescriptions
  const definedLevels = Object.values(levels).filter(
    desc => !isRichTextEmpty(desc),
  ).length
  return { defined: definedLevels, total: 5 }
}
